import { responsiveFontSizes } from "@mui/material";
import { createTheme } from "@mui/material/styles";
import { forwardRef } from "react";
import { Link as RouterLink } from "react-router-dom";
import { light } from "./palette";
import shadows from "./shadows";

const LinkBehavior = forwardRef((props, ref) => {
  const { href, ...other } = props;
  // Map href (Material UI) -> to (react-router)
  return <RouterLink ref={ref} to={href} {...other} />;
});

const getTheme = (mode, themeToggler) =>
  responsiveFontSizes(
    createTheme({
      palette: {
        primary: {
          main: "#248e8a",
        },
        secondary: {
          main: "#73acaa",
        },
        ...light,
      },
      shadows: shadows(mode),
      typography: {
        fontFamily: '"Inter", sans-serif',
        button: {
          textTransform: "none",
          fontWeight: "medium",
        },
      },
      zIndex: {
        appBar: 1200,
        drawer: 1300,
      },
      components: {
        MuiButton: {
          styleOverrides: {
            root: {
              fontWeight: 400,
              borderRadius: 5,
              paddingTop: 10,
              paddingBottom: 10,
            },
            containedSecondary: mode === "light" ? { color: "white" } : {},
          },
        },
        MuiInputBase: {
          styleOverrides: {
            root: {
              borderRadius: 5,
            },
          },
        },
        MuiOutlinedInput: {
          styleOverrides: {
            root: {
              borderRadius: 5,
            },
            input: {
              borderRadius: 5,
            },
          },
        },
        MuiCard: {
          styleOverrides: {
            root: {
              borderRadius: 8,
            },
          },
        },
        MuiLink: {
          defaultProps: {
            component: LinkBehavior,
          },
        },
      },
      themeToggler,
    })
  );

export default getTheme;
